module.exports = __webpack_public_path__ + "img/zx.4f78bc60.png";